import { ApplicationStore } from '../states'

export const updateAuthToken: (state: ApplicationStore, payload: string) => ApplicationStore = (state, payload) => {
  return {
    ...state,
    authToken: payload,
  }
}

export const removeAuthToken: (state: ApplicationStore) => ApplicationStore = (state) => {
  const newState: ApplicationStore = JSON.parse(JSON.stringify(state))

  delete newState.authToken
  return {
    ...newState,
  }
}
